import BaseAPI from '@/apis/base/baseApi';

export default class ShareReportConfigApi extends BaseAPI {
  apiName = 'Business';
}
